<template>
	<view class="box">
		<!-- <view class="box-head">
			<image src="/static/icon/ic_pass@2x.png" mode="widthFix"></image>
			<text>供餐认证已通过</text>
		</view> -->
		<view class="box-error">
			<view class="box-error-top">
				<image src="/static/icon/ic_fail@2x.png" mode="widthFix"></image>
				<text>供餐认证已拒绝</text>
			</view>
			<view class="box-error-info">营业执照过期，请重新提交审核</view>
		</view>
		<view class="box-list">
			<view class="box-list-item">
				<view class="box-list-item-label">认证类型</view>
				<view class="box-list-item-val">
					<text>个人</text>
				</view>
			</view>
			<view class="box-list-item">
				<view class="box-list-item-label">联系人</view>
				<view class="box-list-item-val">
					<text>李万海</text>
				</view>
			</view>
			<view class="box-list-item">
				<view class="box-list-item-label">手机号</view>
				<view class="box-list-item-val">
					<text>18155446667</text>
				</view>
			</view>
			<view class="box-list-item">
				<view class="box-list-item-label">接单位置</view>
				<view class="box-list-item-val">
					<text>安徽省合肥市经开区莲花科技园F座402</text>
					<view class="box-list-item-val-edit">修改</view>
				</view>
			</view>
			<view class="box-list-info">
				<view class="box-list-info-label">身份信息</view>
				<view class="box-list-info-list">
					<view class="box-list-info-list-image">
						<image src="/static/image/btn_guohui@2x.png" mode="widthFix"></image>
					</view>
					<view class="box-list-info-list-image">
						<image src="/static/image/btn_guohui@2x.png" mode="widthFix"></image>
					</view>
				</view>
			</view>
		</view>
		<view class="box-footer">
			<view class="box-footer-btn">重新认证</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			};
		}
	}
</script>

<style lang="scss" scoped>
	.box {
		width: 100%;
		.box-footer {
			width: 100%;
			padding: 0 30rpx;
			box-sizing: border-box;
			margin-top: 60rpx;
			.box-footer-btn {
				width: 100%;
				height: 88rpx;
				line-height: 88rpx;
				text-align: center;
				background: #00BC12;
				border-radius: 44rpx;
				font-weight: 500;
				font-size: 32rpx;
				color: #FFFFFF;
			}
		}
		.box-error {
			width: 100%;
			height: 248rpx;
			background: rgba(190,56,56,0.1);
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			.box-error-top {
				display: flex;
				align-items: center;
				justify-content: center;
				image {
					width: 60rpx;
					height: 60rpx;
					margin-right: 24rpx;
				}
				text {
					font-weight: 600;
					font-size: 40rpx;
					color: #FF0000;
				}
			}
			.box-error-info {
				font-weight: 400;
				font-size: 28rpx;
				color: #333333;
				margin-top: 32rpx;
			}
		}
		.box-head {
			width: 100%;
			height: 172rpx;
			display: flex;
			align-items: center;
			justify-content: center;
			background: rgba(91,190,56,0.1);
			image {
				width: 60rpx;
				height: 60rpx;
				margin-right: 24rpx;
			}
			text {
				font-weight: 600;
				font-size: 40rpx;
				color: #00BC12;
			}
		}
		.box-list {
			width: 100%;
			padding: 0 30rpx;
			box-sizing: border-box;
			.box-list-info {
				width: 100%;
				margin-top: 30rpx;
				.box-list-info-label {
					font-weight: 400;
					font-size: 30rpx;
					color: #777777;
					margin-bottom: 30rpx;
				}
				.box-list-info-list {
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: space-between;
					.box-list-info-list-image {
						width: 334rpx;
						height: 216rpx;
						border-radius: 16rpx;
						overflow: hidden;
						display: flex;
						align-items: center;
						justify-content: center;
						image {
							width: 100%;
						}
					}
				}
			}
			.box-list-item {
				width: 100%;
				box-sizing: border-box;
				padding: 30rpx 0;
				display: flex;
				align-items: start;
				justify-content: space-between;
				border-bottom: 1rpx solid #E5E5E5;
				.box-list-item-label {
					font-weight: 400;
					font-size: 30rpx;
					color: #777777;
					flex-shrink: 0;
					margin-right: 50rpx;
				}
				.box-list-item-val {
					display: flex;
					align-items: start;
					text {
						font-weight: 400;
						font-size: 30rpx;
						color: #222222;
					}
					.box-list-item-val-edit {
						flex-shrink: 0;
						font-weight: 400;
						font-size: 30rpx;
						color: #00BC12;
						margin-left: 20rpx;
					}
				}
			}
		}
	}
</style>
